import React from "react"
import { Helmet } from "react-helmet"
import { StaticQuery, graphql } from "gatsby"

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl
        defaultImage: image
      }
    }
  }
`


const SEO = ({ title, description, image, pathname, article, noindex=false }) => (
    <StaticQuery
        query={query}
        render={({
            site: {
                siteMetadata: {
                    defaultTitle,
                    titleTemplate,
                    defaultDescription,
                    siteUrl,
                    defaultImage,
                },
            },
        }) => {
            const seo = {
                title: title || defaultTitle,
                description: description || defaultDescription,
                image: `${siteUrl}${image || defaultImage}`,
                url: `${siteUrl}${pathname || ""}`,
            }

            return (
                <>
                    <Helmet title={seo.title} titleTemplate={titleTemplate}>
                        <meta name="description" content={seo.description} />
                        <meta name="image" content={seo.image} />
                        {seo.url && <meta property="og:url" content={seo.url} />}
                        {(article ? true : null) && (
                            <meta property="og:type" content="article" />
                        )}
                        {seo.title && <meta property="og:title" content={seo.title} />}
                        {seo.description && (
                            <meta property="og:description" content={seo.description} />
                        )}
                        {seo.image && <meta property="og:image" content={seo.image} />}
                        <meta name="twitter:card" content="summary_large_image" />
                        {seo.title && <meta name="twitter:title" content={seo.title} />}
                        {seo.description && (
                            <meta name="twitter:description" content={seo.description} />
                        )}
                        {seo.image && <meta name="twitter:image" content={seo.image} />}
                        {noindex && <meta name="robots" content="noindex" />}

                        {/* 다국어 hreflang: 언어 prefix를 정규식으로 제거한 basePath로 /en, /ko 양방향 alternate 생성. x-default는 영어. */}
                        {pathname && (() => {
                            const basePath = pathname.replace(/^\/(en|ko)(\/|$)/, "/")
                            const enUrl = `${siteUrl}/en${basePath}`
                            const koUrl = `${siteUrl}/ko${basePath}`
                            return (
                                <>
                                    <link rel="alternate" href={enUrl} hreflang="en" />
                                    <link rel="alternate" href={koUrl} hreflang="ko" />
                                    <link rel="alternate" href={enUrl} hreflang="x-default" />
                                </>
                            )
                        })()}

                    </Helmet>
                </>
            )
        }}
    />
)
export default SEO